module.exports = __webpack_public_path__ + "static/media/bg-image3.e2dac5f5.jpg";